
const {
  isDev,
} = require('./utils')

/**
 * Makes a URL that points to a document or collection in Firestore.
 * For use in admin contexts only.
 *
 * @param {string} path - The Firestore path of the document or collection
 */
exports.makeFirestoreUrl = (path) => {
  return `https://console.firebase.google.com/u/0/project/${isDev ? 'happs-tv-dev' : 'happs-tv'}/firestore/data/~2F${path.replace(/\//g, '~2F')}`
}
